import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { PrivilegeService } from 'apps/resource-portal/src/app/services/privilege.service';

@Component({
  selector: 'concourse-report-dialog',
  templateUrl: './report-dialog.component.html',
  styleUrls: ['./report-dialog.component.scss']
})
export class ReportDialogComponent implements OnInit {
  @Input() selectedDepartment = null;
  @Input() selectedRoom = null;
  @Input() saveToFolder:boolean = false
  //new table
  reportItems = [];
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }
}
